import * as React from 'react';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';

import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import { NameOf } from 'src/utils/NameOf';
import { PageProps } from 'src/models/common/ComponentProps';

import ReportHeader from 'src/components/common/ReportHeader';
import DataTable, { DataTableButtonExport, DataTableColumnProps, Filterer } from 'src/components/common/DataTable';
import ReportRequestDTO from 'src/models/datatable/ReportRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import ReportApiController from 'src/api/ReportApiController';
import ReportHeaderDTO from 'src/models/report/ReportHeaderDTO';
import StudentPlanetCompletionReportDTO from 'src/models/report/StudentPlanetCompletionReportDTO';
import './AdminReports.less';
import { Grades } from 'src/constants/Grades';
import { Icon } from 'antd';

interface StudentPlanetCompletionReportProps extends PageProps<{}> {
}

interface StudentPlanetCompletionReportState {
    isLoading: boolean;
    filterParams: Partial<ReportHeaderDTO>;
}

class StudentPlanetCompletionReport extends React.Component<StudentPlanetCompletionReportProps, StudentPlanetCompletionReportState> {
    private standardDataTableRef: DataTable<StudentPlanetCompletionReportDTO>;

    constructor(props) {
        super(props);
        bindAllOfThis(this, StudentPlanetCompletionReport.prototype);

        this.state = {
            isLoading: false,
            filterParams: null
        };
    }

    private fetchData(requestState: ReportRequestDTO<ReportHeaderDTO>, checkEcho: () => boolean, callback: (response: TableResponseDTO<StudentPlanetCompletionReportDTO>) => void): void {
        // Add custom filtering into the request
        requestState.filterData = this.state.filterParams as ReportHeaderDTO;

        // Show nothing in datatable if there are no filters, represented as {} from the reset function
        if (this.state.filterParams == null) {
            // Clear out the datatable as the clear button ends up here as well
            callback({ results: [], filteredCount: 0 } as TableResponseDTO<StudentPlanetCompletionReportDTO>);
            return;
        }

        this.setState({ isLoading: true });
        ReportApiController.getStudentPlanetCompletionReport(requestState)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                this.setState({
                    isLoading: false
                });

                callback(results.data);
            });
    }

    private handleOnReset() {
        this.setState({ filterParams: null }, () => this.standardDataTableRef.refresh());
    }

    private handleOnSubmit(filterParams: Partial<ReportHeaderDTO>) {
        this.setState({ filterParams }, () => this.standardDataTableRef.refresh());
    }

    private customTableColumns(): DataTableColumnProps<StudentPlanetCompletionReportDTO>[] {
        let columns: DataTableColumnProps<StudentPlanetCompletionReportDTO>[] = [
            DataTable.AdvancedColumns.Text(<Translate id='common.headers.firstName' />, "firstName"),
            DataTable.AdvancedColumns.Text(<Translate id='common.headers.lastName' />, "lastName"),
            DataTable.BetterColumns.Custom(<Translate id='common.headers.currentGrade' />, "currentGradeName", {
                width: 150,
                // Show name but sort on Ids
                sorter: (a, b) => a.currentGradeId - b.currentGradeId
            }),

            DataTable.BetterColumns.Custom(<Translate id='common.headers.activityGrade' />, "activityGradeName", {
                width: 150,
                // Show name but sort on Ids
                sorter: (a, b) => a.activityGradeId - b.activityGradeId
            }),
            DataTable.AdvancedColumns.Custom("R", "planetR", undefined, (record) => (record.planetR ? <i className="green-icon fas fa-check"></i> : <i className="red-icon fas fa-times"></i>)),
            DataTable.AdvancedColumns.Custom("I", "planetI", undefined, (record) => (record.planetI ? <i className="green-icon fas fa-check"></i> : <i className="red-icon fas fa-times"></i>)),
            DataTable.AdvancedColumns.Custom("A", "planetA", undefined, (record) => (record.planetA ? <i className="green-icon fas fa-check"></i> : <i className="red-icon fas fa-times"></i>)),
            DataTable.AdvancedColumns.Custom("S", "planetS", undefined, (record) => (record.planetS ? <i className="green-icon fas fa-check"></i> : <i className="red-icon fas fa-times"></i>)),
            DataTable.AdvancedColumns.Custom("E", "planetE", undefined, (record) => (record.planetE ? <i className="green-icon fas fa-check"></i> : <i className="red-icon fas fa-times"></i>)),
            DataTable.AdvancedColumns.Custom("C", "planetC", undefined, (record) => (record.planetC ? <i className="green-icon fas fa-check"></i> : <i className="red-icon fas fa-times"></i>))
        ];

        return columns;
    }

    render() {
        return (
            <div className="admin-report student-planet-completion-report">
                <h2><Translate id="admin.sideNav.planetCompletionReport" /></h2>
                <p>Planet Completion Detail Report provides quick access to review planets completed by students in your school. Currently, reporting data is available only if student grade has occurred. Please click on the help icon to view a detailed example.</p>
                <p>Activity Grade indicates the Grade level in which student completed the activity.</p>
                <p><Icon className="info-icon" type="info-circle" /> Click these icons for additional information.</p>
                <hr />
                <ReportHeader
                    reportingEvent={"Planet Completion"}
                    isLoading={this.state.isLoading}
                    defaultSchoolYears={"Current"}
                    onSubmit={this.handleOnSubmit}
                    onReset={this.handleOnReset}
                />
                <DataTable
                    ref={ref => this.standardDataTableRef = ref}
                    serverSide={true}
                    tableProps={{
                        // UserId is not unique
                        // rowKey: NameOf<StudentPlanetCompletionReportDTO>("userId"),
                        loading: this.state.isLoading,
                        pagination: {
                            defaultPageSize: 100,
                            showTotal: DataTable.StandardTotalsRenderer,
                            showSizeChanger: true,
                            pageSizeOptions: ["10", "25", "100", "9999"],
                        }
                    }}
                    columns={this.customTableColumns()}
                    data={[]}
                    fetchData={this.fetchData}
                    buttonBar={[
                        new DataTableButtonExport("Planet Completion Report")
                    ]}
                />
            </div>
        );
    }
}

export default StudentPlanetCompletionReport;



// WEBPACK FOOTER //
// ./src/pages/admin/reports/StudentPlanetCompletionReport.tsx